<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
        <path
            fill="url(#paint0_linear)"
            d="M39.24 14.292L28.644 1.252a3.4 3.4 0 00-3.166-1.21L8.867 2.685a3.392 3.392 0 00-2.632 2.134L.223 20.502a3.384 3.384 0 00.535 3.343l10.596 13.052a3.4 3.4 0 003.17 1.198l16.608-2.645a3.384 3.384 0 002.633-2.132l6.012-15.683a3.383 3.383 0 00-.537-3.343z"
        />
        <path
            fill="#fff"
            d="M24.585 11.245l-3.76 6.718-3.697-7.977-4.616 1.229L6.798 26.09h5.098l3.44-8.774 3.388 8.357h2.61l5.014-8.957v11.458l4.757-1.605V12.4l-6.52-1.156z"
        />
        <defs>
            <linearGradient
                id="paint0_linear"
                x1="16.52"
                x2="37.697"
                y1="40.459"
                y2="21.125"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#0397A7" />
                <stop offset=".997" stop-color="#00ECCD" />
            </linearGradient>
        </defs>
    </svg>
</template>
